import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

import { FriendlyDateTime } from '../Date/friendly-date-time'
import { Toast } from '../NarusMaterial'

interface AlertToastInterface {
  close: (id: string) => void
  createdAt: string
  id: string
  patientId: string
  clientName: string
  patientFirstName: string
  patientLastName: string
  title: string
}

export function AlertToast ({ close, createdAt, id, patientId, clientName, patientFirstName, patientLastName, title }: AlertToastInterface): JSX.Element {
  const navigate = useNavigate()

  const handleClose = useCallback((): void => {
    close(id)
  }, [ close, id ])

  function handleCardClick (): void {
    navigate(`/patient/${clientName}/${patientId}/patientFolder`)
  }

  return (
    <Toast onDelete={handleClose}>
      <Content
        onClick={handleCardClick}
        title={title}
        createdAt={createdAt}
        patientFirstName={patientFirstName}
        patientLastName={patientLastName}
      />
    </Toast>
  )
}

interface ContentProps {
  title: string
  patientFirstName: string
  patientLastName: string
  createdAt: string
  onClick: () => void
}

function Content ({
  title,
  patientFirstName,
  patientLastName,
  createdAt,
  onClick
}: ContentProps): JSX.Element {
  return (
    <button
      onClick={onClick}
      className='cursor-pointer'
    >
      <h2>{patientFirstName} {patientLastName}</h2>

      {typeof title === 'string' && (
        <p>{title.replace(/ -> /g, ' → ')}</p>
      )}

      <p className='time'>
        <FriendlyDateTime datetime={createdAt} />
      </p>
    </button>
  )
}
